import { Command, CommandRegistry, MenuContribution, MenuModelRegistry } from '@theia/core';
import {
    AbstractViewContribution,
    CommonMenus,
    FrontendApplication,
    FrontendApplicationContribution
} from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import { SubjectsPanel } from './subjects-panel';

const SubjectsCommand: Command = { id: 'lvgl-subjects:open', label: 'Subjects: Open' };

@injectable()
export class SubjectsPanelContribution
    extends AbstractViewContribution<SubjectsPanel>
    implements FrontendApplicationContribution, MenuContribution
{
    async onDidInitializeLayout(_app: FrontendApplication): Promise<void> {
        await this.openView({ activate: false, reveal: false });
    }

    constructor() {
        super({
            widgetId: SubjectsPanel.ID,
            widgetName: SubjectsPanel.LABEL,
            defaultWidgetOptions: { area: 'bottom' },
            toggleCommandId: SubjectsCommand.id
        });
    }

    override registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(SubjectsCommand, {
            execute: async () => {
                const widget = await this.widgetManager.getOrCreateWidget<SubjectsPanel>(SubjectsPanel.ID);
                await this.shell.addWidget(widget, { area: 'bottom' });
                await this.shell.activateWidget(widget.id);
            }
        });
    }

    override registerMenus(menus: MenuModelRegistry): void {
        menus.registerMenuAction(CommonMenus.VIEW_VIEWS, {
            commandId: SubjectsCommand.id,
            label: SubjectsPanel.LABEL
        });
    }
}
